import Select from "../../main/Select";

function TimezoneSelectView({
  options,
  value,
  onChange,
  disabled,
  nullable,
  placeholder,
}) {
  return (
    <Select
      options={options}
      value={value}
      onChange={onChange}
      disabled={disabled}
      nullable={nullable}
      placeholder={placeholder}
      searchable={true}
    />
  );
}

export default TimezoneSelectView;
